await themeComponent(theme.components['mc-element'], false);

class McViewer extends McElement {
    static MAX = 11;

    connectedCallback() {
        const handle = this.dataset.handle;
        if (!handle) return;

        McViewer.add(handle);
    }

    static getCurrentProductHandle() {
        return document.querySelector('#current-product')?.dataset.handle;
    }

    static getViewed = () => {
        try {
            return JSON.parse(localStorage.getItem('viewed')) || [];
        } catch {
            return [];
        }
    }

    static add(handle) {
        let viewed = McViewer.getViewed().filter(Boolean);
        const index = viewed.indexOf(handle);

        if (index !== -1) {
            viewed.splice(index, 1); // Remove if already exists
        }

        viewed.push(handle);

        // Keep only the newest MAX items
        while (viewed.length > McViewer.MAX) {
            viewed.shift();
        }

        localStorage.setItem('viewed', JSON.stringify(viewed));
        console.log('[mc-viewer] saved:', viewed); // Optional: debug log
    }
}

if (!window.customElements.get('mc-viewer')) {
    window.customElements.define('mc-viewer', McViewer);
}
window.McViewer = McViewer;
